import { store } from '@/store'
import { PPTElementShadow } from '@/types/slides'
import { computed, Ref, ref } from 'vue'
const richTextAttrs = computed(() => store.state.richTextAttrs)
const org_val = richTextAttrs.value.fontsize.replace('px', '')
const new_val = 20
const val_num = (Number(new_val) / Number(org_val)).toFixed(3)
// 计算元素的阴影样式
export default (shadow: Ref<PPTElementShadow | undefined>) => {
  const shadowStyles = computed(() => {
    if (shadow.value) {
      let arr = []
      if (typeof shadow.value === 'object') {
        if (shadow.value.h) {
          arr.push(shadow.value)
        }
        else {
          arr = shadow.value as any
        }
       
      }
      else {
        arr = shadow.value
      }
      const s = ref('')
      if (arr.length > 0) {
        arr.forEach((item: { h: any; v: any; blur: any; color: any }) => {
          let dd = ''
          dd = item.h * Number(val_num) + 'px ' + item.v * Number(val_num) + 'px ' + item.blur * Number(val_num) + 'px ' + item.color + ', '
          s.value += dd
        })
      }
      s.value = s.value.substring(0, s.value.length - 2)
      return s.value
    }
    return ''
  })

  return {
    shadowStyles,
  }
}